export enum RoleEnum {
  ADMIN = "admin",
  HOLDER = "holder",
  OFFICER = "officer",
  USER = "user",
}
